<template>
    <div class="w-full">
        <div class="w-full flex justify-between items-center">
            <Back />
            <a
            @click.prevent="nextStep"
            class="focus:outline-none cursor-pointer text-white text-sm py-1 px-2 rounded-md bg-red-500 hover:bg-red-600 hover:shadow-lg flex items-center"
            >
                Selanjutnya : {{whatsNext == '' ? 'Selesai' : 'Tambah ' + whatsNext}}
                <i class="fas fa-arrow-right ml-2"></i>
            </a>
        </div>
        <div>
            <Step
                :classroom="classroom"
                :step="step"
            />
        </div>
        <div class="mx-auto">
            <div class="w-full mt-5">
                <div class="md:grid md:grid-cols-3 md:gap-6">
                    <div class="md:col-span-1">
                        <p class="mb-2">Form Modul</p>
                        <form action="#" method="POST">
                            <div class="shadow sm:rounded-md sm:overflow-hidden">
                                <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                                    <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="first_name" class="block text-sm font-medium text-gray-700">Judul Modul</label>
                                            <input v-model="formModule.title" type="text" name="first_name" id="first_name" autocomplete="given-name"
                                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Nama judul modul">
                                        </div>
                                    </div>

                                    

                                    <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="slug" class="block text-sm font-medium text-gray-700">Slug</label>
                                            <input v-model="formModule.slug" type="text" name="slug" id="slug" autocomplete="given-name"
                                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="nama-slug-modul">
                                            <p class="text-sm text-gray-500 mt-1">
                                                Contoh slug: https://modul.sekolahdesain.id/<span class="font-semibold text-red-500">nama-slug-modul</span>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="w-full">
                                        <label for="link" class="block text-sm font-medium text-gray-700">
                                           File Modul
                                        </label>
                                        <!-- <iframe v-if="formModule.file" :src="fileUrl" style="width:100%; height:200px;" frameborder="0"></iframe> -->
                                        <input @change="uploadModule" ref="fileUpload" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" type="file">
                                        <p class="text-sm text-gray-500 mt-1">File modul harus bertipe PDF</p>
                                    </div>

                                        <!-- <div class="w-full">
                                            <label for="link" class="block text-sm font-medium text-gray-700">
                                                Thumbnail
                                            </label>
                                            <img v-if="formModule.thumbnail" :src="thumbnailUrl" alt="">
                                        <input @change="uploadThumbnail" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" type="file">
                                            
                                        </div> -->
                                    

                                    <!-- <div class="w-full">
                                        <label for="about" class="block text-sm font-medium text-gray-700">
                                            Deskripsi singkat
                                        </label>
                                        <div class="mt-1">
                                            <textarea v-model="formModule.shortDescription" id="about" name="about" rows="3"
                                                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                                                placeholder="you@example.com"></textarea>
                                        </div>
                                        <p class="mt-2 text-sm text-gray-500">
                                            Brief description for modul.
                                        </p>
                                    </div>

                                    <div class="w-full">
                                        <label for="about" class="block text-sm font-medium text-gray-700">
                                            Deskripsi
                                        </label>
                                        <div class="mt-1">
                                            <textarea v-model="formModule.description" id="about" name="about" rows="3"
                                                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                                                placeholder="you@example.com"></textarea>
                                        </div>
                                        <p class="mt-2 text-sm text-gray-500">
                                            Description for modul.
                                        </p>
                                    </div> -->

                                

                                    <!-- <div class="w-full">
                                            <div class="col-span-6 sm:col-span-3">
                                            <label for="ordering" class="block text-sm font-medium text-gray-700">Ordering</label>
                                            <input v-model="formModule.ordering" type="number" name="ordering" id="ordering" autocomplete="given-name"
                                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                            </div>
                                        </div> -->

                                    
                                </div>
                                <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                    <button @click.prevent="submit" type="submit"
                                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        Tambah
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="mt-3 md:mt-0 md:col-span-2">
                        <p class="mb-2">Daftar Modul</p>
                        <div class="p-3 bg-white shadow sm:rounded-md sm:overflow-hidden">
                            <DataTable :value="moduls"  @rowReorder="onRowReorder" responsiveLayout="scroll" class="p-datatable-sm font-sans text-sm">
                                <template #empty>
                                    No Data found.
                                </template>
                                <template #loading>
                                    Loading Modul data. Please wait.
                                </template>
                                <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field"></Column>
                                <Column field="id" header="Aksi" headerStyle="width: 8.5rem;">
                                    <template #body="{data}">
                                        
                                        <a @click="showEditModul(data.id)"  type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:w-auto sm:text-sm">
                                            <i class="fas fa-edit"></i>
                                        </a>

                                        <a @click="showDeleteModul(data.id)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-2 sm:w-auto sm:text-sm">
                                            <i class="fas fa-trash-alt"></i>
                                        </a>
                                        
                                        <a @click="modulePreview(data)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-2 sm:w-auto sm:text-sm">
                                            <i class="fas fa-book-open"></i>
                                        </a>
                                    
                                    </template>
                                </Column>
                                <Column :rowReorder="true" headerStyle="width: 2rem" :reorderableColumn="false" class="cursor-move px-0" />
                            </DataTable>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- modal preview -->
        <transition name="pop">
        <div
            v-if="modulePreviewModal"
            class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
        >
            <div class="relative w-3/4 md:w-1/2 my-6 mx-auto h-5/6">
                <div v-click-away="closeModulePreview"  class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full h-full bg-white outline-none focus:outline-none">
                    <div
                    class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
                        <h3 class="text-xl font-semibold text-white">
                            Modul Preview
                        </h3>
                        <button
                            class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                            v-on:click="closeModulePreview()">
                            <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
                        </button>
                    </div>
                    <div class="relative px-6 pt-3 pb-6 h-full mb-3">
                        <div class="w-full pb-2">
                            <span class="font-bold">
                                {{ selectedModule?.title }}
                            </span>
                        </div>
                        <div class="w-full h-full pb-3">
                            <iframe
                                :src="selectedModule?.file"
                                width="100%"
                                height="100%"
                            >
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </transition>
        <Delete
            :display="displayDeleteModul"
            title="Delete Modul?"
            note=""
            :close="closeDeleteModul"
            :deleteBtn="modulDelete"
        />
        <!-- modal edit modul -->
        <transition name="pop">
        <div v-if="displayEditModul"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
            <div class="relative w-3/4 md:w-1/3 m-auto">
                <div class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-85">
                    <div
                        class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
                        <h3 class="text-xl font-semibold text-white">
                            Ubah Modul
                        </h3>
                        <button
                        class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                        v-on:click="closeEditModul">
                        <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
                        </button>
                    </div>
                    <div class="relative px-6 py-3 overflow-y-auto overflow-x-hidden">
                        <div class="w-full pb-3">
                            <label for="title" class="block text-sm font-medium text-gray-700">Judul Modul</label>
                            <input v-model="formModuleEdit.title" type="text" name="title" id="title" autocomplete="given-name"
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Nama judul modul">
                        </div>
                        <div class="w-full pb-3">
                            <label for="slug" class="block text-sm font-medium text-gray-700">Slug</label>
                            <input v-model="formModuleEdit.slug" type="text" name="slug_edit" id="slug_edit" autocomplete="given-name"
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="nama-slug-modul">
                            <p class="text-sm text-gray-500 mt-1">
                                Contoh slug: https://modul.sekolahdesain.id/<span class="font-semibold text-red-500">nama-slug-modul</span>
                            </p>
                        </div>
                        <div class="w-full">
                            <label for="link" class="block text-sm font-medium text-gray-700">
                                File Modul
                            </label>
                            <iframe v-if="formModuleEdit.file" :src="fileUrl" style="width:100%; height:100%;" frameborder="0"></iframe>
                            <input @change="uploadModule" ref="fileUpload" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" type="file">
                            <p class="text-sm text-gray-500 mt-1">File modul harus bertipe PDF</p>
                        </div>
                    </div>
                    <div class="text-right px-6 py-3">
                        <button @click.prevent="submitEdit"
                        class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600"
                        type="button" 
                        style="transition: all .15s ease"
                        >
                            Ubah
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </transition>
        <Toast />
    </div>
</template>
<script>
                  
import Back from '@/layout/Component/Back'
import Step from '@/layout/Component/Step'
import Delete from '@/layout/Component/Delete'
// import moment from 'moment'
import {
    mapActions,
    mapGetters
} from 'vuex'

export default {

    components: {
        Back,
        Step,
        Delete,
    },

    data() {
        return {
            formModule: {
                classroomLevelId: 0,
                title: '',
                slug: '',
                shortDescription: '',
                description: '',
                thumbnail: '',
                file: '',
                ordering: 0,
            },
            formModuleEdit: {
                classroomLevelId: 0,
                title: '',
                slug: '',
                shortDescription: '',
                description: '',
                thumbnail: '',
                file: '',
                ordering: 0,
            },
            fileUrl: '',
            thumbnailUrl: '',
            classroomLevel: {},
            classroomId: 0,
            modulId: 0,
            columns: [
                {
                    field: 'ordering',
                    header: 'Urutan'
                },
                {
                    field: 'id',
                    header: 'ID'
                },
                {
                    field: 'title',
                    header: 'Judul'
                },
            ],
            moduls: null,
            whatsNext: '',
            step: 2,
            selectedModule: {},
            modulePreviewModal: false,
            displayDeleteModul: false,
            displayEditModul: false,
        }
    },
    async created() {
        this.classroomId = this.$route.params.classroomId

        if (this.classroomId && (this.classroom?.id != this.classroomId)) {
            this.getClassroomDetail()
        } else {
            this.next()
        }
         
        if ((this.modulList?.length == 0) || (this.classroomId != this.savedIdClassroomModule)) {
            await this.fetchAllModuls(this.classroomId)
        }
        this.moduls = this.modulList
        // console.log(this.videoList)
       

    },
    computed: {
        ...mapGetters(["classroom", "modulList", "modul", "isSuccessModul", "messageModul", "isLoadingModul", "savedIdClassroomModule"]),
    },

    methods: {
        ...mapActions(["fetchDetailClassroom", "fetchAllModuls", "deleteModul", "fetchDetailModul", "updateModul", "addModul"]),
        async getClassroomDetail() {
            await this.fetchDetailClassroom(this.classroomId)
            // console.log(this.classroom)
             this.next()
              
        },
        next() {
            if(this.classroom?.must_quiz_tab) {
                this.whatsNext = 'quiz'
                
            } else if(this.classroom?.must_webinar_tab) {
                this.whatsNext = 'webinar'
                
            } else {
                this.whatsNext = ''
                    
            }
        },
        async onRowReorder(event) {
           const effectedModule = []
           this.moduls.forEach(async (el, i) => {
                if(el.id == event.value[i].id ) {
                    effectedModule.push(false)
                } else {
                    effectedModule.push(true)       
                }
           });
           const check = effectedModule.some(el => el == true)
           if(check) {
               for (let i = 0; i < effectedModule.length ; i++) {
                    if(effectedModule[i]) {
                        const payload = {
                            title: event.value[i]?.title,
                            slug: event.value[i]?.slug,
                            classroomLevelId: event.value[i]?.classroom?.levels[0].id,
                            shortDescription: event.value[i]?.short_description,
                            description: event.value[i]?.description,
                            file: event.value[i]?.file,
                            ordering: i + 1,
                            thumbnail: event.value[i]?.thumbnail,
                            classroomId: null
                        }
                        const data = {
                            id: event.value[i]?.id,
                            payload: payload
                        }
                        this.moduls[i].ordering = i + 1
                        await this.updateModul(data)
                    }
                }
    
                await this.fetchAllModuls(this.classroomId)
                this.moduls = this.modulList

                this.$toast.add({
                    severity: 'success',
                    summary: 'success',
                    detail: 'sukses dipindah',
                    life: 1000
                })
           }
        },
        showDeleteModul(id) {
            this.modulId = id 
            this.displayDeleteModul = true
        },
        closeDeleteModul() {
            this.modulId = null
            this.displayDeleteModul = false
        },
        async modulDelete() {
            const indexDeleted = this.moduls.findIndex(el => el.id == this.modulId)
            await this.deleteModul(this.modulId)
            if (this.isSuccessModul) {
                this.closeDeleteModul()
                this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: this.messageModul,
                    life: 1000
                })

                this.moduls.splice(indexDeleted,1)
                const effectedModule = []
                this.moduls.forEach(async (el, i) => {
                if(el.ordering == i + 1 ) {
                    effectedModule.push(false)
                } else {
                    effectedModule.push(true)       
                }
                });
                const check = effectedModule.some(el => el == true)
                if(check) {
                    for (let i = 0; i < effectedModule.length ; i++) {
                        if(effectedModule[i]) {
                            const payload = {
                                title: this.moduls[i]?.title,
                                slug: this.moduls[i]?.slug,
                                classroomLevelId: this.moduls[i]?.classroom?.levels[0].id,
                                shortDescription: this.moduls[i]?.short_description,
                                description: this.moduls[i]?.description,
                                file: this.moduls[i]?.file,
                                ordering: i + 1,
                                thumbnail: this.moduls[i]?.thumbnail,
                                classroomId: null
                            }
                            const data = {
                                id: this.moduls[i]?.id,
                                payload: payload
                            }
                            this.moduls[i].ordering = i + 1
                            await this.updateModul(data)
                        }
                    }
            
                    this.$toast.add({
                        severity: 'success',
                        summary: 'success',
                        detail: 'sukses dipindah',
                        life: 1000
                    })
                }
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: this.messageModul
                })
            }
        },

        async submit() {
            this.formModule.classroomLevelId = this.classroom?.levels[0].id

            if (this.moduls?.length) {
                this.formModule.ordering = this.moduls?.length + 1
            } else {
                this.formModule.ordering = 1
            }

            if (
                this.formModule.title &&
                this.formModule.slug &&
                this.formModule.classroomLevelId &&
                this.formModule.file &&
                this.formModule.ordering
            ) {
                if (this.modulId) {
                    const modul = {
                        id: this.modulId,
                        payload: this.formModule
                    }

                    await this.updateModul(modul)
                    if (this.isSuccessModul) {
                        this.fetchAllModuls(this.classroomId)
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.messageModul,
                            life: 1000
                        })
                        setTimeout(() => this.$router.go(-1), 1000)
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Failed',
                            detail: this.messageModul
                        })
                    }
                } else {
                    await this.addModul(this.formModule)
                    if (this.isSuccessModul) {
                        await this.fetchAllModuls(this.classroomId)
                        this.formModule = {}
                        this.$refs.fileUpload.value = null
                        this.moduls = this.modulList
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.messageModul,
                            life: 1000
                        })
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Failed',
                            detail: this.messageModul
                        })
                    }
                }
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'semua form harus diisi',
                    life: 3000
                })
            }

        },

        uploadModule(event) {
            if(event.target.files[0].type == 'application/pdf') {
                if(this.modulId > 0) {
                    this.formModuleEdit.file = event.target.files[0]
                } else {
                    this.formModule.file = event.target.files[0]
                }
                this.file = URL.createObjectURL(event.target.files[0])
            } else {
                this.$refs.fileUpload.value = null;
                this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'File modul harus bertipe pdf'
                })
            }
        },
        uploadThumbnail(event) {
            this.formModule.thumbnail = event.target.files[0]
            this.thumbnailUrl = URL.createObjectURL(event.target.files[0])
        },

        nextStep(){
            let confirmation
            if(!this.moduls?.length) {
                confirmation = confirm('Tidak ada modul dalam kelas ini, apakah yakin ingin ke langkah selanjutnya?')
            } else {
                confirmation = confirm('Apakah yakin ingin ke langkah selanjutnya?')
            }

            if(confirmation) {
                if(this.whatsNext != '') {
                        this.$router.push('/classroom/' + this.classroom.id + '/step/' + this.whatsNext)
                } else {
                        this.$router.push('/classroom/' + this.classroom.id + '/detail')
                }
            }
        },
        modulePreview(data) {
            this.modulePreviewModal = true
            this.selectedModule = data
        },
        closeModulePreview() {
            this.modulePreviewModal = false
        },
        async showEditModul(id) {
            this.modulId = id
            await this.getModul()
            this.displayEditModul = true          
        },

        async getModul() {
            await this.fetchDetailModul(this.modulId)
            if (this.modul) {
                this.formModuleEdit.title = this.modul.title
                this.formModuleEdit.slug = this.modul.slug
                this.formModuleEdit.classroomLevelId = this.modul.classroom.levels[0].id
                this.formModuleEdit.shortDescription = this.modul.short_description
                this.formModuleEdit.description = this.modul.description
                this.formModuleEdit.file = this.modul.file
                this.fileUrl = this.modul.file
                this.formModuleEdit.ordering = this.modul.ordering
                this.formModuleEdit.thumbnail = this.modul.thumbnail
            }
        },
        closeEditModul() {
            this.displayEditModul = false
            this.modulId = 0
            this.formModuleEdit.classroomLevelId = 0
            this.formModuleEdit.title = ''
            this.formModuleEdit.slug = 0
            this.formModuleEdit.shortDescription = ''
            this.formModuleEdit.description = ''
            this.formModuleEdit.thumbnail = ''
            this.formModuleEdit.file = ''
            this.formModuleEdit.ordering = 0
        },

        async submitEdit() {
            this.formModuleEdit.classroomLevelId = this.classroom?.levels[0].id
            if (
                this.formModuleEdit.title &&
                this.formModuleEdit.slug &&
                this.formModuleEdit.classroomLevelId &&
                this.formModuleEdit.file &&
                this.formModuleEdit.ordering
            ) {
                if (this.modulId) {
                    const modul = {
                        id: this.modulId,
                        payload: this.formModuleEdit
                    }

                    await this.updateModul(modul)
                    if (this.isSuccessModul) {
                        this.closeEditModul()
                        this.$refs.fileUpload.value = null
                        await this.fetchAllModuls(this.classroomId)
                        this.moduls = this.modulList
                        
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.messageModul,
                            life: 1000
                        })
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Failed',
                            detail: this.messageModul
                        })
                    }
                }
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'semua form harus diisi',
                    life: 3000
                })
            }

        },

    }
}
</script>